import { isPlainObject, isPromise } from './objects';
/**
 * This function deep merges objects, concatenates array and handles promises as values.
 */
// biome-ignore lint/suspicious/noExplicitAny: -
export function pulseMerge(target, ...sources) {
    return sources.reduce((acc, source) => mergeValue(acc, source), target);
    function innerMerge(target, source) {
        for (const [key, value] of Object.entries(source)) {
            target[key] = mergeValue(target[key], value);
        }
    }
    // biome-ignore lint/suspicious/noExplicitAny: -
    function mergeValue(targetValue, value) {
        if (isPromise(targetValue) || isPromise(value)) {
            return Promise.all([targetValue, value]).then(([targetValue, value]) => {
                const copiedTarget = isPlainObject(targetValue) ? { ...targetValue } : targetValue;
                return mergeValue(copiedTarget, value);
            });
        }
        if (Array.isArray(value)) {
            if (!Array.isArray(targetValue)) {
                return value.filter((v) => v !== undefined);
            }
            return [...targetValue, ...value].filter((v) => v !== undefined);
        }
        if (typeof value === 'object') {
            if (targetValue && value && typeof targetValue === 'object') {
                innerMerge(targetValue, value);
                return targetValue;
            }
            return value ? { ...value } : value;
        }
        return value ?? targetValue ?? undefined;
    }
}
